import { render, staticRenderFns } from "./ReturnUser.vue?vue&type=template&id=6f29ac67&"
import script from "./ReturnUser.vue?vue&type=script&lang=js&"
export * from "./ReturnUser.vue?vue&type=script&lang=js&"
import style0 from "./ReturnUser.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports